class NumberedCardSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.swiperEl = this.querySelector('.swiper');
    if (!this.swiperEl) return;

    const config = {
      slidesPerView: parseFloat(this.dataset.colsMobile) || 1.2,
      spaceBetween: parseInt(this.dataset.gap, 10) || 16,
      grabCursor: true,
      watchOverflow: true,
      threshold: 5,
      resistance: true,
      resistanceRatio: 0.5,
      breakpoints: {
        750: {
          slidesPerView: parseFloat(this.dataset.colsTablet) || 2.5,
        },
        990: {
          slidesPerView: parseFloat(this.dataset.colsDesktop) || 4.5,
        },
      },
      navigation: {
        nextEl: this.querySelector('.numbered-card-slider__nav--next'),
        prevEl: this.querySelector('.numbered-card-slider__nav--prev'),
        disabledClass: 'swiper-button-disabled',
        lockClass: 'swiper-button-lock',
      },
    };

    this.initSwiper(config);
  }

  initSwiper(config) {
    if (typeof Swiper === 'undefined') {
      // Swiper CDN may not be loaded yet — retry shortly
      this.swiperRetryTimer = setTimeout(() => this.initSwiper(config), 50);
      return;
    }
    this.swiper = new Swiper(this.swiperEl, config);
  }

  disconnectedCallback() {
    if (this.swiperRetryTimer) {
      clearTimeout(this.swiperRetryTimer);
      this.swiperRetryTimer = null;
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('numbered-card-slider')) {
  customElements.define('numbered-card-slider', NumberedCardSlider);
}